module.exports = __webpack_public_path__ + "static/media/gray-info-icon.e907de28.svg";